import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

const HtmlHeader = ({ data, containsAlternateHref }) => (
  <Helmet>
    <title>{data.template.meta_title}</title>
    <meta name="description" content={data.template.meta_description} />
    <meta name="keywords" content={data.template.meta_keywords} />
    <link rel="canonical" href={data.pageUrl || data.template.sample_url} />
    {containsAlternateHref && (
      <link
        rel="alternate"
        href={
          data.template.language === 'hindi'
            ? data.pageUrl.replace('railways/hi/', 'railways/')
            : data.pageUrl.replace('railways/', 'railways/hi/')
        }
        hrefLang={data.template.language === 'hindi' ? 'en-in' : 'hi-in'}
      />
    )}
  </Helmet>
);

HtmlHeader.propTypes = {
  data: PropTypes.object,
  containsAlternateHref: PropTypes.bool
};

export default HtmlHeader;
